import React, { useState, useRef, useEffect } from "react";
import ItemModal from "../Modal/ItemModal";

// CSS สำหรับ drag and drop
const dragDropStyles = `
  .dragging {
    opacity: 0.5 !important;
    transform: scale(0.98);
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  }
  
  .drag-over {
    background-color: #e3f2fd !important;
    border-top: 3px solid #2196F3 !important;
    border-bottom: 3px solid #2196F3 !important;
  }
  
  .bom-group-row {
    background-color: #f8f9fa !important;
    border-left: 4px solid #2196F3 !important;
  }
  
  .bom-parent-row {
    background-color: #e8f4fd !important;
    border-left: 6px solid #1976D2 !important;
    font-weight: 500;
  }
  
  .bom-child-row {
    background-color: #f0f8ff !important;
    border-left: 4px solid #64B5F6 !important;
    padding-left: 20px;
  }
  
  .spec-row {
    background-color: #fff3e0 !important;
    border-left: 4px solid #FF9800 !important;
    font-style: italic;
  }
  
  .drag-handle {
    cursor: grab !important;
    transition: color 0.2s ease;
  }
  
  .drag-handle:hover {
    color: #2196F3 !important;
  }
  
  .drag-handle:active {
    cursor: grabbing !important;
  }
  
  tbody tr[draggable="true"]:hover {
    background-color: #f5f5f5;
    transition: background-color 0.2s ease;
  }
  
  .drag-preview {
    position: absolute;
    background: white;
    border: 2px solid #2196F3;
    border-radius: 4px;
    padding: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    z-index: 1000;
    pointer-events: none;
  }
`;

// เพิ่ม styles เข้าไปใน document head
if (typeof document !== 'undefined' && !document.getElementById('drag-drop-styles')) {
  const styleElement = document.createElement('style');
  styleElement.id = 'drag-drop-styles';
  styleElement.textContent = dragDropStyles;
  document.head.appendChild(styleElement);
}

const ItemTable = ({
  formDetailList,
  handleChangeDetail,
  handleDuplicateRow,
  handleRemoveRow,
  formatCurrency,
  showItemModal,
  handleItemClose,
  itemDataList,
  onRowSelectItem,
  handleItemShow,
  whDataList,
  showWarehouseModal,
  handleWarehouseClose,
  handleWarehouseShow,
  onRowSelectWh,
  handleFocus,
  handleBlur,
  disabledRec,
  disabled,
  poDataList,
  handlePOShow,
  onRowSelectItem02,
  showAddEmptyButton,
  setFormDetailList,
  onRowSelectItemForEdit,
}) => {
  // console.debug("poDList",poDList)
  // ถ้าเป็นหน้าใบสั่งซื้อและใบรับสินค้า ให้แสดง Column จำนวนรับ / จำนวนค้างรับ
  const isPurchaseOrderOrReceipt = () => {
    return (
      window.location.pathname === "/purchase-order" ||
      window.location.pathname === "/purchase-receipt"
    );
  };

  // ถ้าเป็นหน้าใบสั่งซื้อและใบรับสินค้า ให้กำหนด Width จำนวนรับ / จำนวนค้างรับ
  const getColumnWidth = () => {
    if (window.location.pathname === "/purchase-order") {
      return "13%";
    } else if (window.location.pathname === "/purchase-receipt") {
      return "21%";
    } else if (window.location.pathname === "/product-receipt") {
      return "10%";
    } else {
      return "21%";
    }
  };

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [newItemName, setNewItemName] = useState("");

  // Drag and Drop states
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [draggedGroupItems, setDraggedGroupItems] = useState([]);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  // Ref สำหรับ table container
  const tableContainerRef = useRef(null);

  const handleOpenModal = (index, item) => {
    setEditingItem(index);
    if (window.location.pathname === "/purchase-request") {
      setNewItemName(item.itemNameEN);
    } else {
      setNewItemName(item.itemName || ""); // เซ็ตค่าเริ่มต้น
    }

    setShowEditModal(true);
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
    setEditingItem(null);
    setNewItemName("");
  };

  const handleSaveChanges = () => {
    if (editingItem !== null && setFormDetailList) {
      setFormDetailList((prevList) => {
        const updatedList = [...prevList];
        if (window.location.pathname === "/purchase-request") {
          updatedList[editingItem].itemNameEN = newItemName;
        } else {
          updatedList[editingItem].itemName = newItemName;
        }
        return updatedList;
      });

      if (!setFormDetailList && handleChangeDetail) {
        if (window.location.pathname === "/purchase-request") {
          handleChangeDetail(editingItem, "itemNameEN", newItemName);
        } else {
          handleChangeDetail(editingItem, "itemName", newItemName);
        }
      }
    }
    handleCloseModal();
  };

  const handleCheckboxChange = (index) => {
    setFormDetailList((prevList) => {
      const updatedList = [...prevList];
      const currentItem = updatedList[index];

      const isGift = !currentItem.isGift;

      const originalName = currentItem.itemName.replace(/^FREE\s+/i, "");

      updatedList[index] = {
        ...currentItem,
        isGift,
        itemName: isGift ? `FREE ${originalName}` : originalName,
        realPriceBeforeGift: isGift
          ? currentItem.itemPriceUnit // เก็บราคาก่อนเป็นของแถม
          : currentItem.realPriceBeforeGift, // ใช้ราคาก่อนหน้าที่เก็บไว้
        itemPriceUnit: isGift
          ? "0.00"
          : currentItem.realPriceBeforeGift || currentItem.itemPriceUnit,
        itemTotal: isGift
          ? "0.00"
          : formatCurrency(
            parseFloat(currentItem.itemQty || 0) *
            parseFloat(
              currentItem.realPriceBeforeGift || currentItem.itemPriceUnit
            )
          ),
      };

      return updatedList;
    });
  };

  const textareaRefs = useRef([]);

  const [editItemIndex, setEditItemIndex] = useState(null);
  const handleChangeItem = (index) => {
    setEditItemIndex(index);
    handleItemShow();
  };

  // Note: handleSelectItemWrapper was removed as unused to satisfy linter

  useEffect(() => {
    formDetailList.forEach((_, index) => {
      const el = textareaRefs.current[index];
      if (el) {
        el.style.height = "auto";
        el.style.height = el.scrollHeight + "px";
      }
    });
  }, [formDetailList]);

  // ฟังก์ชันสำหรับเลื่อนตารางแบบนุ่มนวล
  const scrollTable = (direction) => {
    if (tableContainerRef.current) {
      const container = tableContainerRef.current;
      const scrollAmount = 3; // ลดจำนวน pixel ที่เลื่อนในครั้งหนึ่ง

      if (direction === 'up') {
        container.scrollTop = Math.max(0, container.scrollTop - scrollAmount);
      } else if (direction === 'down') {
        container.scrollTop = container.scrollTop + scrollAmount;
      }
    }
  };

  // ฟังก์ชันสำหรับเริ่มลาก
  const handleDragStart = (e, index) => {
    const item = formDetailList[index];
    setDraggedIndex(index);

    // ถ้าเป็น BOM/Project Item ให้หาลูก BOM ทั้งหมด
    const isSpecRow = item.isSpecRow === true && item.itemId !== 1;

    if (item.isProjectItem && item.itemId !== 1) {
      const bomChildren = [];
      let currentIndex = index + 1;

      // หาแถว Spec ถัดไป (ถ้ามี)
      if (currentIndex < formDetailList.length && (formDetailList[currentIndex].isSpecRow === true && formDetailList[currentIndex].itemId !== 1)) {
        bomChildren.push(currentIndex);
        currentIndex++;
      }

      // หาลูก BOM ทั้งหมด
      while (currentIndex < formDetailList.length && (formDetailList[currentIndex].isBOMChild === true && formDetailList[currentIndex].itemId !== 1)) {
        bomChildren.push(currentIndex);
        currentIndex++;
      }

      setDraggedGroupItems([index, ...bomChildren]);

      // แสดงข้อความแจ้งเตือนว่าเป็นการลาก BOM Group
      e.dataTransfer.setData('text/plain', `กำลังลาก BOM Group (${bomChildren.length + 1} รายการ)`);
    } else if (isSpecRow) {
      // ถ้าลากแถว Spec ให้ลากพร้อมกับ parent ด้วย
      const parentIndex = index - 1;
      if (parentIndex >= 0 && formDetailList[parentIndex].isProjectItem && formDetailList[parentIndex].itemId !== 1) {
        handleDragStart(e, parentIndex);
        return;
      }
      setDraggedGroupItems([index]);
    } else {
      // สินค้าธรรมดา
      const groupItems = [index];

      // ตรวจสอบว่ามีแถว Spec ถัดไปไหม
      if (index + 1 < formDetailList.length && (formDetailList[index + 1].isSpecRow === true && formDetailList[index + 1].itemId !== 1)) {
        groupItems.push(index + 1);
      }

      setDraggedGroupItems(groupItems);

      if (groupItems.length > 1) {
        e.dataTransfer.setData('text/plain', `กำลังลากสินค้าพร้อม Spec (${groupItems.length} รายการ)`);
      } else {
        e.dataTransfer.setData('text/plain', 'กำลังลากสินค้า');
      }
    }

    e.dataTransfer.effectAllowed = 'move';
  };

  // ฟังก์ชันสำหรับตอนลากผ่าน
  const handleDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setDragOverIndex(index);

    // เช็คว่าลากขึ้นหรือลง และเลื่อนตารางตามทิศทาง
    if (draggedIndex !== null && tableContainerRef.current) {
      const container = tableContainerRef.current;
      const rect = container.getBoundingClientRect();
      const y = e.clientY - rect.top;

      // เช็คว่าเมาส์อยู่ใกล้ขอบบนหรือขอบล่าง
      const scrollTriggerZone = 80; // ลดขนาดพื้นที่ trigger

      if (y < scrollTriggerZone) {
        // ลากใกล้ขอบบน ให้เลื่อนขึ้น
        scrollTable('up');
      } else if (y > rect.height - scrollTriggerZone) {
        // ลากใกล้ขอบล่าง ให้เลื่อนลง
        scrollTable('down');
      }
    }
  };

  // ฟังก์ชันสำหรับตอนปล่อย
  const handleDrop = (e, dropIndex) => {
    e.preventDefault();

    if (draggedIndex === null || draggedGroupItems.length === 0) return;

    // ป้องกันการ drop ที่ตำแหน่งเดิม
    if (draggedGroupItems.includes(dropIndex)) return;

    const newList = [...formDetailList];
    const draggedItems = draggedGroupItems.map(index => newList[index]);

    // ลบรายการที่ลากออกจากตำแหน่งเดิม (เรียงจากมากไปน้อยเพื่อไม่ให้ index เปลี่ยน)
    draggedGroupItems.sort((a, b) => b - a).forEach(index => {
      newList.splice(index, 1);
    });

    // คำนวณตำแหน่งใหม่หลังจากลบรายการ
    let adjustedDropIndex = dropIndex;
    draggedGroupItems.forEach(index => {
      if (index < dropIndex) {
        adjustedDropIndex--;
      }
    });

    // แทรกรายการที่ลากในตำแหน่งใหม่
    newList.splice(adjustedDropIndex, 0, ...draggedItems);

    setFormDetailList(newList);

    // Reset states
    setDraggedIndex(null);
    setDraggedGroupItems([]);
    setDragOverIndex(null);

    // แสดงข้อความแจ้งเตือนการจัดเรียงสำเร็จ
    if (draggedItems.length > 1) {
      console.log(`จัดเรียง ${draggedItems.length} รายการเรียบร้อยแล้ว`);
    }
  };

  // ฟังก์ชันสำหรับตอนลากออกจากพื้นที่
  const handleDragLeave = () => {
    setDragOverIndex(null);
  };

  // ฟังก์ชันสำหรับตอนจบการลาก
  const handleDragEnd = () => {
    setDraggedIndex(null);
    setDraggedGroupItems([]);
    setDragOverIndex(null);
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title">รายละเอียดสินค้า</h4>
          <div className="d-flex align-items-center">
            <button
              className="btn text-white mx-3"
              onClick={handleItemShow}
              style={{
                backgroundColor: "rgb(239, 108, 0)",
                whiteSpace: "nowrap",
                padding: "10px",
                fontSize: "15px",
              }}
              disabled={
                window.location.pathname !== "/product-receipt" ? disabled : false
              }
            >
              <i className="fa fa-plus"></i> เพิ่มรายการ
            </button>
          </div>
        </div>
        <ItemModal
          formDetailList={formDetailList}
          showItemModal={showItemModal}
          handleItemClose={handleItemClose}
          itemDataList={itemDataList}
          onRowSelectItem={(item) => {
            const selected = Array.isArray(item) ? item[0] : item;

            if (editItemIndex !== null) {
              onRowSelectItemForEdit(selected, editItemIndex);
              setEditItemIndex(null);
            } else {
              onRowSelectItem(Array.isArray(item) ? item : [item]);
            }
          }}
          onRowSelectItem02={onRowSelectItem02}
          showAddEmptyButton={showAddEmptyButton}
        />
        <div className="card-body">
          <div
            className="table-responsive"
            style={{ maxHeight: "500px", overflowY: "auto" }}
            ref={tableContainerRef}
          >
            <table
              id="basic-datatables"
              className="table table-striped table-hover"
            >
              <thead className="thead-dark">
                <tr>
                  {/* <th className="text-center" style={{ width: "3%" }}>
                    <i className="fas fa-arrows-alt" title="ลากเพื่อจัดเรียง"></i>
                  </th> */}
                  <th className="text-center" style={{ width: "1%" }}>
                    #
                  </th>
                  <th className="text-center" style={{ width: "5%" }}>
                    รหัสสินค้า
                  </th>
                  <th
                    className=""
                    style={{ width: "0%", textAlign: "center" }}
                    hidden={window.location.pathname !== "/purchase-request"}
                  >
                    FREE
                  </th>
                  <th
                    className="text-center"
                    style={
                      window.location.pathname === "/purchase-order"
                        ? { width: "12%" }
                        : { width: "20%" }
                    }
                  >
                    ชื่อสินค้า
                  </th>
                  <th
                    className="text-center"
                    hidden={
                      window.location.pathname === "/billofsale" ||
                        window.location.pathname === "/bill" ||
                        // || window.location.pathname === '/order-product'
                        window.location.pathname === "/picking-list" ||
                        window.location.pathname === "/invoice"
                        ? false
                        : true
                    }
                    style={{ width: "12%" }}
                  >
                    คลังสินค้า
                    <i
                      onClick={handleWarehouseShow}
                      className="fa fa-search-plus"
                      style={{
                        position: "absolute",
                        cursor: "pointer",
                        fontSize: "18px",
                        marginLeft: "35px",
                      }}
                      hidden={
                        window.location.pathname === "/bill" ||
                        window.location.pathname === "/picking-list"
                      }
                    />
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/billofsale" ||
                        // window.location.pathname !== "/bill" ||
                        // || window.location.pathname === '/order-product'
                        window.location.pathname === "/picking-list" ||
                        window.location.pathname === "/invoice"
                        ? false
                        : true
                    }
                    className="text-center"
                    style={{ width: "8%" }}
                  >
                    จำนวนคงคลัง
                  </th>
                  <th className="text-center" style={{ width: "8%" }}>
                    จำนวน
                    {window.location.pathname === "/billofsale" ||
                      window.location.pathname === "/bill"
                      ? "ขาย"
                      : ""}
                    {window.location.pathname === "/order-product"
                      ? "ออเดอร์"
                      : ""}
                    {window.location.pathname === "/picking-list"
                      ? "ออเดอร์"
                      : ""}
                    {window.location.pathname === "/purchase-order"
                      ? "(PO)"
                      : ""}
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/purchase-order"
                        ? false
                        : true
                    }
                    className="text-center"
                    style={{ width: "8%" }}
                  >
                    จำนวนรับ
                  </th>
                  <th
                    hidden={!isPurchaseOrderOrReceipt()}
                    className="text-center"
                    style={{ width: "8%" }}
                  >
                    จำนวนค้างรับ{" "}
                    {window.location.pathname === "/purchase-order"
                      ? "(PO)"
                      : ""}
                  </th>
                  <th className="text-center" style={{ width: "6%" }}>
                    หน่วย
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/order-product" ||
                        window.location.pathname === "/picking-list"
                        ? true
                        : false
                    }
                    className="text-center"
                    style={{ width: "8%" }}
                  >
                    ราคาต่อหน่วย
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/order-product" ||
                        window.location.pathname === "/picking-list"
                        ? true
                        : false
                    }
                    className="text-center"
                    style={{ width: "8%" }}
                  >
                    ส่วนลด
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/order-product" ||
                        window.location.pathname === "/picking-list"
                        ? true
                        : false
                    }
                    className="text-center"
                    style={{ width: "5%" }}
                  >
                    %
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/order-product" ||
                        window.location.pathname === "/picking-list"
                        ? true
                        : false
                    }
                    className="text-center"
                    style={
                      window.location.pathname === "/deposit-document" ||
                        window.location.pathname === "/purchase-request" ||
                        window.location.pathname === "/purchase-order"
                        ? { width: "10%" }
                        : { width: "7%" }
                    }
                  >
                    จำนวนเงินรวม
                  </th>
                  <th
                    className="text-center"
                    style={{ width: getColumnWidth() }}
                    hidden={
                      window.location.pathname === "/deposit-document" ||
                      window.location.pathname === "/purchase-request" ||
                      window.location.pathname === "/purchase-order" ||
                      window.location.pathname === "/billofsale" ||
                      window.location.pathname === "/bill" ||
                      window.location.pathname === "/order-product" ||
                      window.location.pathname === "/picking-list" ||
                      window.location.pathname === "/quotation" ||
                      window.location.pathname === "/taxes" ||
                      window.location.pathname === "/invoice" ||
                      window.location.pathname === "/credit-note" ||
                      window.location.pathname === "/debit-note"
                      // ||  window.location.pathname === '/product-receipt'
                    }
                  >
                    คลังสินค้า
                    <i
                      onClick={handleWarehouseShow}
                      className="fa fa-search-plus"
                      style={{
                        position: "absolute",
                        cursor: "pointer",
                        fontSize: "18px",
                        marginLeft: "5px",
                      }}
                      hidden={
                        window.location.pathname === "/product-receipt"
                          ? false
                          : true
                      }
                    />
                  </th>
                  <th
                    className="text-center"
                    style={{ width: getColumnWidth() }}
                    hidden={window.location.pathname !== "/product-receipt"}
                  >
                    เลขเอกสารอ้างอิง
                    {/* <i
                      // onClick={handleWarehouseShow}
                      className="fa fa-search-plus"
                      style={{
                        position: "absolute",
                        cursor: "pointer",
                        fontSize: "18px",
                        marginLeft: "35px",
                      }}
                      hidden={
                        window.location.pathname === "/product-receipt"
                          ? false
                          : true
                      }
                    /> */}
                  </th>
                  <th
                    className="text-center"
                    style={{ width: "6%" }}
                    hidden={
                      window.location.pathname === "/quotation" ||
                        window.location.pathname === "/order-product" ||
                        window.location.pathname === "/billofsale" ||
                        window.location.pathname === "/purchase-request"
                        ? false
                        : true
                    }
                  >
                    แก้ไข
                  </th>
                  <th
                    className="text-center"
                    style={{ width: "3%" }}
                    hidden={
                      ![
                        "/product-receipt",
                        "/purchase-request",
                        "/purchase-order",
                        "/quotation",
                        "/invoice",
                        "/credit-note",
                        "/debit-note",
                        "/bill",
                      ].includes(window.location.pathname)
                    }
                  >
                    ลบ
                  </th>
                  <th
                    className="text-center"
                    style={{ width: "3%" }}
                    hidden={
                      ![
                        "/product-receipt",
                        "/purchase-request",
                        "/purchase-order",
                        "/quotation",
                        "/invoice",
                        "/credit-note",
                        "/debit-note",
                        "/bill",
                      ].includes(window.location.pathname)
                    }
                  >
                    เปลี่ยนสินค้า
                  </th>
                </tr>
              </thead>
              <tbody>
                {formDetailList.length > 0 ? (
                  formDetailList.map((item, index) => {
                    const isDragging = draggedGroupItems.includes(index);
                    const isDragOver = dragOverIndex === index;
                    const isPartOfBOMGroup = (item.isProjectItem && item.itemId !== 1) || (item.isBOMChild === true && item.itemId !== 1) || (item.isSpecRow === true && item.itemId !== 1);

                    return (
                      <tr
                        key={`${item.itemId || "item"}-${index}`}
                        draggable={!disabled}
                        onDragStart={(e) => handleDragStart(e, index)}
                        onDragOver={(e) => handleDragOver(e, index)}
                        onDrop={(e) => handleDrop(e, index)}
                        onDragLeave={handleDragLeave}
                        onDragEnd={handleDragEnd}
                        style={{
                          opacity: isDragging ? 0.5 : 1,
                          backgroundColor: isDragOver ? '#e3f2fd' : isPartOfBOMGroup ? '#f8f9fa' : 'transparent',
                          borderLeft: isPartOfBOMGroup ? '4px solid #2196F3' : 'none',
                          cursor: disabled ? 'default' : 'move'
                        }}
                        className={isDragging ? 'dragging' : ''}
                      >
                        {/* Drag Handle */}
                        {/* <td className="text-center" style={{ verticalAlign: 'middle' }}>
                          {!disabled && (
                            <i 
                              className="fas fa-grip-vertical drag-handle" 
                              style={{ 
                                cursor: 'grab', 
                                color: isPartOfBOMGroup ? '#2196F3' : '#666',
                                fontSize: '16px'
                              }}
                              title={isPartOfBOMGroup ? 'ลาก BOM Group' : 'ลากรายการ'}
                            ></i>
                          )}
                        </td> */}
                        {/* # */}
                        <td className="text-center">{index + 1}</td>

                        {/* รหัสสินค้า */}
                        <td className="text-center">
                          <span>
                            {item.itemCode === "BOM" ? "" : item.itemCode || ""}
                          </span>
                        </td>

                        <td
                          className="text-center"
                          hidden={
                            window.location.pathname !== "/purchase-request"
                          }
                        >
                          <input
                            type="checkbox"
                            checked={item.isGift || false}
                            onChange={() => handleCheckboxChange(index)}
                            style={{ width: "50px" }}
                          />
                        </td>

                        {/* ชื่อสินค้า */}
                        <td className="text-left">
                          {["/quotation", "/invoice"].includes(
                            window.location.pathname
                          ) ? (
                            <textarea
                              name="item_Spec"
                              readOnly
                              rows={1}
                              ref={(el) => (textareaRefs.current[index] = el)}
                              style={{
                                // cursor: "pointer",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #ced4da",
                                borderRadius: "4px",
                                fontSize: "16px",
                                textDecoration: "none",
                                color: "#212529",
                                display: "inline-block",
                                width: "100%",
                                background: "white",
                                padding: "10px 15px",
                                overflow: "hidden",
                                resize: "none",
                                lineHeight: 1.5,
                                overflowY: "auto",
                                maxHeight: "107px",
                              }}
                              value={item.itemName || "คลิกเพื่อแก้ไข"}
                              onClick={() => handleOpenModal(index, item)}
                            />
                          ) : (
                            <textarea
                              name="item_Spec"
                              readOnly
                              rows={1}
                              ref={(el) => (textareaRefs.current[index] = el)}
                              style={{
                                // cursor: "pointer",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #ced4da",
                                borderRadius: "4px",
                                fontSize: "16px",
                                textDecoration: "none",
                                color: "#212529",
                                display: "inline-block",
                                width: "100%",
                                background: "white",
                                padding: "10px 15px",
                                overflow: "hidden",
                                resize: "none",
                                lineHeight: 1.5,
                                overflowY: "auto",
                                maxHeight: "107px",
                              }}
                              value={
                                window.location.pathname === "/purchase-request"
                                  ? item.isGift
                                    ? `FREE ${item.itemNameEN}`
                                    : item.itemNameEN
                                  : item.itemName || "คลิกเพื่อแก้ไข"
                              }
                              onClick={() => handleOpenModal(index, item)}
                            />

                            // <span>
                            //   {window.location.pathname === "/purchase-request"
                            //     ? item.isGift
                            //       ? `FREE ${item.itemNameEN}`
                            //       : item.itemNameEN
                            //     : item.itemName || ""}
                            // </span>
                          )}
                        </td>

                        {/* คลังสินค้า */}
                        <td
                          className="text-center"
                          hidden={
                            window.location.pathname === "/billofsale" ||
                              window.location.pathname === "/bill" ||
                              window.location.pathname === "/picking-list" ||
                              window.location.pathname === "/invoice"
                              ? false
                              : true
                          }
                        >
                          <select
                            name="whId"
                            value={item.whId || ""} // ใช้ค่า null หรือ undefined เป็น empty string เพื่อให้เลือกได้
                            onChange={(e) =>
                              handleChangeDetail(index, "whId", e.target.value)
                            }
                            className="form-select form-control"
                            disabled={
                              window.location.pathname === "/product-receipt" ||
                                window.location.pathname === "/billofsale" ||
                                window.location.pathname === "/invoice"
                                ? !disabled || disabledRec
                                  ? true
                                  : false
                                : disabled
                            }
                          >
                            <option value={""}>กรุณาเลือกคลัง</option>
                            {whDataList.map((warehouse) => (
                              <option
                                key={warehouse.WH_Id}
                                value={warehouse.WH_Id}
                              >
                                {warehouse.WH_Name}
                              </option>
                            ))}
                          </select>
                        </td>

                        {/* จำนวนคงคลัง */}
                        <td
                          hidden={
                            window.location.pathname === "/billofsale" ||
                              // window.location.pathname !== "/bill" ||
                              window.location.pathname === "/picking-list" ||
                              window.location.pathname === "/invoice"
                              ? false
                              : true
                          }
                          className="text-center"
                        >
                          {item.itemOnHand === "-" ? ( // ถ้า loading เป็น true หรือ itemOnHand ไม่มีค่า
                            <i className="fa fa-spinner fa-spin"></i>
                          ) : (
                            <span>{formatCurrency(item.itemOnHand) || 0}</span>
                          )}
                        </td>

                        {/* จำนวน */}
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control text-center"
                            value={item.itemQty || ""}
                            onChange={(e) =>
                              handleChangeDetail(index, "itemQty", e.target.value)
                            }
                            onFocus={(e) => handleFocus(index, "itemQty")}
                            onBlur={(e) =>
                              handleBlur(index, "itemQty", e.target.value)
                            }
                            disabled={
                              item.isSpecRow // Spec row ห้ามแก้ไขจำนวน
                                ? true
                                : window.location.pathname === "/product-receipt"
                                  ? false
                                  : item.itemCode === "BOM"
                                    ? true
                                    : disabled
                            }
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                                e.target.value = inputValue.slice(0, -1);
                              }
                            }}
                          />
                        </td>

                        {/* จำนวนรับ */}
                        <td
                          hidden={
                            window.location.pathname === "/purchase-order"
                              ? false
                              : true
                          }
                          className="text-center"
                        >
                          {/* {disabled ? (
                                                <span>{item.itemRecQty || 0}</span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control text-center"
                                                    value={item.itemRecQty || 0}
                                                    onChange={(e) => handleChangeDetail(index, 'itemRecQty', e.target.value)}
                                                    disabled={disabled}
                                                />
                                            )} */}
                          <input
                            type="text"
                            className="form-control text-center"
                            value={item.itemRecQty || 0}
                            onChange={(e) =>
                              handleChangeDetail(
                                index,
                                "itemRecQty",
                                e.target.value
                              )
                            }
                            disabled={disabled}
                            onInput={(e) => {
                              if (/^0+/.test(e.target.value)) {
                                e.target.value = e.target.value.replace(
                                  /^0+/,
                                  ""

                                );

                                // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                                if (e.target.value.startsWith(".")) {
                                  e.target.value = "0" + e.target.value;
                                }
                              }
                            }}
                          />
                        </td>

                        {/* จำนวนค้างรับ */}
                        <td
                          hidden={!isPurchaseOrderOrReceipt()}
                          className="text-center"
                        >
                          <input
                            type="text"
                            className="form-control text-center"
                            value={item.itemRecBalance || 0} // ใช้ค่า 0 แทน undefined
                            onChange={(e) =>
                              handleChangeDetail(
                                index,
                                "itemRecBalance",
                                e.target.value
                              )
                            }
                            disabled={disabled}
                            onInput={(e) => {
                              if (/^0+/.test(e.target.value)) {
                                const inputValue = e.target.value;

                                // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                                if (
                                  inputValue.startsWith(".") &&
                                  inputValue !== "."
                                ) {
                                  e.target.value = "0" + inputValue;
                                }
                              }
                            }}
                          />
                        </td>

                        {/* หน่วย */}
                        <td className="text-center">
                          {/* {disabled ? (
                                                <span>{item.itemUnit || ''}</span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.itemUnit || ''}
                                                    disabled={true}
                                                    onChange={(e) => handleChangeDetail(index, 'itemUnit', e.target.value)}
                                                />
                                            )} */}
                          <input
                            type="text"
                            className="form-control"
                            value={item.itemUnit || ""}
                            disabled={true}
                            onChange={(e) =>
                              handleChangeDetail(
                                index,
                                "itemUnit",
                                e.target.value
                              )
                            }
                          />
                        </td>

                        {/* ราคาต่อหน่วย */}
                        <td
                          className="text-end"
                          hidden={
                            window.location.pathname === "/order-product" ||
                              window.location.pathname === "/picking-list"
                              ? true
                              : false
                          }
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                            }}
                          >

                            {/* Input สำหรับแสดงราคาต่อหน่วย และสามารถกดแก้ไขได้ */}
                            {item.isEditingPrice ? (
                              <>
                                {item.showPriceSelection ? null : (
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    value={item.itemPriceUnit || ""}
                                    onChange={(e) => {
                                      const newValue = e.target.value;
                                      // ตรวจสอบว่าเป็นของแถมหรือไม่
                                      if (
                                        !item.isGift &&
                                        parseFloat(newValue) === 0
                                      ) {
                                        alert(
                                          "ราคาต่อหน่วยต้องไม่เป็น 0 เว้นแต่เป็นของแถม"
                                        );
                                        return;
                                      }
                                      handleChangeDetail(
                                        index,
                                        "itemPriceUnit",
                                        newValue
                                      );
                                    }}
                                    onFocus={(e) =>
                                      handleFocus(index, "itemPriceUnit")
                                    }
                                    onBlur={(e) => {
                                      handleBlur(
                                        index,
                                        "itemPriceUnit",
                                        e.target.value
                                      );
                                      // เมื่อ blur ให้กลับเป็นโหมด readOnly
                                      setFormDetailList((prevList) =>
                                        prevList.map((itm, i) =>
                                          i === index
                                            ? { ...itm, isEditingPrice: false }
                                            : itm
                                        )
                                      );
                                    }}
                                    disabled={
                                      item.isSpecRow // Spec row ห้ามแก้ไขราคา
                                        ? true
                                        : item.itemCode === "BOM"
                                          ? true
                                          : false
                                    }

                                    style={{
                                      paddingRight: "30px", // เพิ่มพื้นที่ขวาให้ปุ่ม 🔍
                                    }}
                                  />
                                )}
                              </>
                            ) : (
                              <>
                                {item.showPriceSelection ? null : (
                                  <>
                                    <input
                                      type="text"
                                      className="form-control text-end"
                                      value={item.itemPriceUnit || ""}
                                      readOnly
                                      onClick={() => {
                                        // Spec row ห้ามแก้ไขราคา
                                        if (item.isSpecRow) return;
                                        setFormDetailList((prevList) =>
                                          prevList.map((itm, i) =>
                                            i === index
                                              ? { ...itm, isEditingPrice: true }
                                              : itm
                                          )
                                        )
                                      }}
                                      style={{
                                        paddingRight: "30px",
                                        cursor: item.isSpecRow ? "not-allowed" : "pointer",
                                      }}
                                      onFocus={(e) =>
                                        handleFocus(index, "itemPriceUnit")
                                      }
                                      onBlur={(e) =>
                                        handleBlur(
                                          index,
                                          "itemPriceUnit",
                                          e.target.value
                                        )
                                      }
                                    // disabled={
                                    //   item.itemCode === "BOM"
                                    //     ? true
                                    //     : disabled || item.isGift
                                    // }
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </td>

                        {/* ส่วนลด */}
                        <td
                          hidden={
                            window.location.pathname === "/order-product" ||
                              window.location.pathname === "/picking-list"
                              ? true
                              : false
                          }
                          className="text-end"
                        >
                          <input
                            type="text"
                            className="form-control text-end"
                            value={item.itemDiscount || ""}
                            onChange={(e) =>
                              handleChangeDetail(
                                index,
                                "itemDiscount",
                                e.target.value
                              )
                            }
                            onFocus={(e) => handleFocus(index, "itemDiscount")}
                            onBlur={(e) =>
                              handleBlur(index, "itemDiscount", e.target.value)
                            }
                            disabled={
                              item.isSpecRow // Spec row ห้ามแก้ไขส่วนลด
                                ? true
                                : window.location.pathname === "/product-receipt"
                                  ? false
                                  : item.itemCode === "BOM"
                                    ? true
                                    : disabled
                            }
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                                e.target.value = inputValue.slice(0, -1);
                              }
                            }}
                          />
                        </td>

                        {/* % */}
                        <td
                          hidden={
                            window.location.pathname === "/order-product" ||
                              window.location.pathname === "/picking-list"
                              ? true
                              : false
                          }
                          className="text-center"
                        >
                          {/* {disabled ? (
                                                <span>{item.itemDisType === "1" ? "฿" : item.itemDisType === "2" ? "%" : ""}</span>
                                            ) : (
                                                <select
                                                    className="form-select"
                                                    value={item.itemDisType || ''}
                                                    onChange={(e) => handleChangeDetail(index, 'itemDisType', e.target.value)}
                                                    disabled={disabled}
                                                >
                                                    <option value="1">฿</option>
                                                    <option value="2">%</option>
                                                </select>
                                            )} */}
                          <select
                            className="form-select"
                            value={item.itemDisType || ""}
                            onChange={(e) =>
                              handleChangeDetail(
                                index,
                                "itemDisType",
                                e.target.value
                              )
                            }
                            disabled={item.isSpecRow ? true : disabled} // Spec row ห้ามแก้ไข % หรือ ฿
                          >
                            <option value="1">฿</option>
                            <option value="2">%</option>
                          </select>
                        </td>

                        {/* จำนวนเงินรวม */}
                        <td
                          hidden={
                            window.location.pathname === "/order-product" ||
                              window.location.pathname === "/picking-list"
                              ? true
                              : false
                          }
                          className="text-end"
                        >
                          <span>{formatCurrency(item.itemTotal || 0)}</span>
                        </td>

                        {/* คลังสินค้า */}
                        <td
                          className="text-center"
                          hidden={[
                            "/deposit-document",
                            "/purchase-request",
                            "/purchase-order",
                            "/order-product",
                            "/picking-list",
                            "/billofsale",
                            "/bill",
                            "/quotation",
                            "/taxes",
                            "/invoice",
                            "/credit-note",
                            "/debit-note",
                          ].includes(window.location.pathname)}
                        >
                          {(() => {
                            // if (
                            //   [1, 23, 24, 25, 26, 27, 28].includes(item.itemGroup)
                            // ) {
                            //   item.whId = ""; // กำหนดค่า item.whId เป็นว่าง
                            // }

                            return (
                              <select
                                name="whId"
                                value={item.whId}
                                onChange={(e) =>
                                  handleChangeDetail(
                                    index,
                                    "whId",
                                    e.target.value
                                  )
                                }
                                className="form-select form-control"
                                disabled={
                                  window.location.pathname !== "/product-receipt"
                                    ? !disabled || disabledRec
                                    : disabled
                                  //   ||
                                  // [1, 23, 24, 25, 26, 27, 28].includes(
                                  //   item.itemGroup
                                  // )
                                }
                              >
                                <option value={""}></option>
                                {whDataList.map((warehouse) => (
                                  <option
                                    key={warehouse.WH_Id}
                                    value={warehouse.WH_Id}
                                  >
                                    {warehouse.WH_Name}
                                  </option>
                                ))}
                              </select>
                            );
                          })()}
                        </td>

                        <td
                          className="text-center"
                          hidden={[
                            "/deposit-document",
                            "/purchase-request",
                            "/purchase-order",
                            "/order-product",
                            "/picking-list",
                            "/billofsale",
                            "/bill",
                            "/quotation",
                            "/taxes",
                            "/invoice",
                            "/credit-note",
                            "/debit-note",
                          ].includes(window.location.pathname)}
                        >
                          {(() => {
                            // if (
                            //   [1, 23, 24, 25, 26, 27, 28].includes(item.itemGroup)
                            // ) {
                            //   item.whId = ""; // กำหนดค่า item.whId เป็นว่าง
                            // }
                            return (
                              <>
                                {item?.Ref_Doc !== "" &&
                                  item?.Ref_Doc !== null &&
                                  item?.Ref_Doc !== undefined ? (
                                  <p> {item?.Ref_Doc} </p>
                                ) : (
                                  <select
                                    name="Ref_Doc"
                                    value={item?.Ref_Doc}
                                    onChange={(e) =>
                                      handleChangeDetail(
                                        index,
                                        "Ref_Doc",
                                        e.target.value
                                      )
                                    }
                                    className="form-select form-control"
                                    disabled={
                                      window.location.pathname !==
                                        "/product-receipt"
                                        ? !disabled || disabledRec
                                        : disabled
                                    }
                                  >
                                    <option value={""}>{"ไม่ระบุ"}</option>
                                    {poDataList?.map((po) => (
                                      <option key={po.Doc_ID} value={po.Doc_No}>
                                        {po.Doc_No}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </>
                            );
                          })()}
                        </td>

                        {/* แก้ไข */}
                        <td
                          className="text-center"
                          hidden={
                            window.location.pathname === "/quotation" ||
                              window.location.pathname === "/order-product" ||
                              window.location.pathname === "/billofsale" ||
                              window.location.pathname === "/purchase-request"
                              ? false
                              : true
                          }
                        >
                          <button
                            type="button"
                            className="btn btn-warning"
                            onClick={() => handleDuplicateRow(index)}
                            disabled={disabled}
                          >
                            ทำซ้ำ
                          </button>
                        </td>

                        {/* ลบ */}
                        <td
                          className="text-center"
                          hidden={
                            ![
                              "/product-receipt",
                              "/purchase-request",
                              "/purchase-order",
                              "/quotation",
                              "/invoice",
                              "/credit-note",
                              "/debit-note",
                            ].includes(window.location.pathname)
                          }
                        >
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => handleRemoveRow(index)}
                            disabled={
                              ![
                                "/product-receipt",
                                "/purchase-request",
                                "/purchase-order",
                                "/quotation",
                                "/invoice",
                                "/credit-note",
                                "/debit-note",
                              ].includes(window.location.pathname) ||
                              (item.isBOMChild === true && item.itemId !== 1) ||
                              (item.isSpecRow === true && item.itemId !== 1)
                            }
                            title={
                              (item.isBOMChild === true && item.itemId !== 1)
                                ? "ไม่สามารถลบรายการ BOM ได้โดยตรง ต้องลบผ่านรายการหลัก"
                                : (item.isSpecRow === true && item.itemId !== 1)
                                  ? "ไม่สามารถลบรายการ Spec ได้โดยตรง ต้องลบผ่านรายการหลัก"
                                  : ""
                            }
                          >
                            ลบ
                          </button>
                        </td>

                        <td
                          className="text-center"
                          hidden={
                            ![
                              "/product-receipt",
                              "/purchase-request",
                              "/purchase-order",
                              "/quotation",
                              "/invoice",
                              "/credit-note",
                              "/debit-note",
                            ].includes(window.location.pathname)
                          }
                        >
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => handleChangeItem(index)}
                            disabled={
                              ![
                                "/product-receipt",
                                "/purchase-request",
                                "/purchase-order",
                                "/quotation",
                                "/invoice",
                                "/credit-note",
                                "/debit-note",
                              ].includes(window.location.pathname)
                            }
                          >
                            เปลี่ยน
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="14">
                      <center>
                        <h5>ไม่พบรายการสินค้า</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Modal คลังสินค้า */}
            <div
              className={`modal fade ${showWarehouseModal ? "show" : ""}`}
              style={{ display: showWarehouseModal ? "block" : "none" }}
              tabIndex="-1"
              role="dialog"
            >
              <div
                className="modal-dialog modal-lg"
                style={{ maxWidth: "35%" }}
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <div className="d-flex align-items-center">
                      <h4 className="card-title">คลังสินค้า</h4>
                    </div>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleWarehouseClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "650px", overflowY: "auto" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-dark">
                          <tr>
                            <th
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              รหัสคลังสินค้า
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "80%" }}
                            >
                              ชื่อคลังสินค้า
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {whDataList && whDataList.length > 0 ? (
                            whDataList.map((warehouse, index) => (
                              <tr
                                key={warehouse.Item_Id || index + 1}
                                onClick={() => onRowSelectWh(warehouse)}
                                style={{ cursor: "pointer" }}
                              >
                                <td className="text-center">
                                  {warehouse.WH_Code}
                                </td>
                                <td className="text-left">
                                  {warehouse.WH_Name}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2">
                                <center>
                                  <h5>ไม่พบข้อมูล</h5>
                                </center>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-lg btn-danger"
                      onClick={handleWarehouseClose}
                    >
                      ปิด
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {showEditModal && (
              <div className="modal fade show" style={{ display: "block" }}>
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">แก้ไขชื่อสินค้า</h5>
                      <button
                        className="btn-close"
                        onClick={handleCloseModal}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <textarea
                        className="form-control"
                        value={newItemName}
                        onChange={(e) => setNewItemName(e.target.value)}
                        // maxLength={200}
                        rows={5} // ให้เริ่มต้นเล็กสุด แต่ขยายเมื่อพิมพ์เพิ่ม
                        style={{
                          minHeight: "50px",
                          maxHeight: "300px",
                          resize: "none", // ไม่ให้ผู้ใช้ปรับเอง แต่ขยายอัตโนมัติ
                          overflowY: "auto",
                          lineHeight: "1.8", // ปรับระยะห่างระหว่างบรรทัด
                          padding: "10px", // เพิ่มพื้นที่ให้พิมพ์ง่ายขึ้น
                          fontSize: "16px", // ให้ตัวหนังสืออ่านง่าย
                        }}
                        onInput={(e) => {
                          e.target.style.height = "auto";
                          const newHeight = Math.min(
                            e.target.scrollHeight,
                            300
                          );
                          e.target.style.height = newHeight + "px";
                        }}
                      />
                    </div>
                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={handleCloseModal}
                      >
                        ยกเลิก
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleSaveChanges}
                      >
                        บันทึก
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {showWarehouseModal && (
              <div className="modal-backdrop fade show"></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemTable;
